
define(
    'VintenCloud.PdpCountDown.PdpCountDown'
    , [
    ]
    , function (
    ) {
        'use strict';

        return {
            mount: function mount(container) {
                container.layout.on('afterAppendView', function (view) {
                    var days=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];

                    function addDays(date, days) {
                        var result = new Date(date);
                        result.setDate(result.getDate() + days);
                        return result;
                      }

                    setTimeout(function () {
                        var $countDownBox = container.layout.$el.find("#count-down,#in-modal-countdown");

                        $countDownBox.each(function () {

                            var today = new Date();
                            
                            var delivery = new Date(today);
                            var tomorrow = addDays(today, 1);
                            var weekend = false;
                            var ship="Monday";

                            delivery.setHours(17);
                            delivery.setMinutes(30);

                            var time = (delivery.getTime() - today.getTime()) / 60000;
                            if(time<0){
                                tomorrow = addDays(tomorrow,1);
                                weekend=true;
                            }
                            while(tomorrow.getDay()==0||tomorrow.getDay()==1){
                                tomorrow = addDays(tomorrow,1);
                                weekend=true;
                            }
                            ship=days[(tomorrow.getDay()-1)%7];

                            var options = {
                                weekday: "long",
                                year: "numeric",
                                month: "long",
                                day: "numeric"
                            };
                            var body = "For UK delivery " + tomorrow.toLocaleDateString(
                                "en-UK",
                                options
                            ) + "<br/>";
                            body += "<span class='heading-desc'>";
                            if (weekend) {
                                body += "Order "+ship+" before 5:30pm";
                            } else {
                                body += "Order within";

                                if (time >= 60) {
                                    var hours = Math.floor(time / 60);
                                    time -= (hours * 60);
                                    body += " " + hours + " HRS";
                                }
                                if (time > 0) {

                                    body += " " + time + " MINS";
                                }

                            }

                            var nextDay="Next Working Day";
                            if(tomorrow.getDay()==6){
                                nextDay="Saturday";
                            }

                            body += "</span> to qualify. (Bank Holidays Excluded) <br/><br/> Choose <span class='heading-desc-red'> "+nextDay+" </span> delivery at checkout";

                            $(this).html(body);


                        });
                    }, 800)
                })
            }
        };
    });
